/**
 * Manage torrents
 */
import {
  TorrentState,
  FETCH_TORRENTS_PENDING,
  FETCH_TORRENTS_SUCCESS,
  FETCH_TORRENTS_ERROR,
  TorrentActions,
  SET_ACTIVE_TORRENT,
  SET_SELECTED_TORRENTS,
  TOGGLE_TORRENT_PENDING,
  SET_ACTIVE_TORRENT_FILES,
  SYNC_TORRENT_STATS,
  SET_ACTIVE_TORRENT_TRACKERS,
  SET_TORRENTS_COUNT
} from "../types";

const initialState: TorrentState = {
  pending: false,
  list: [],
  count: 0,
  error: undefined,
  active: undefined,
  selected: [],
  size: 50
};

export default function (
  state = initialState,
  action: TorrentActions
): TorrentState {
  switch (action.type) {
    case FETCH_TORRENTS_PENDING:
      return {
        ...state,
        pending: true
      };
    case FETCH_TORRENTS_SUCCESS:
      return {
        ...state,
        pending: false,
        list: action.append
          ? [...state.list, ...action.torrents]
          : action.torrents
      };
    case SET_TORRENTS_COUNT:
      return {
        ...state,
        count: action.count
      };
    case FETCH_TORRENTS_ERROR:
      return {
        ...state,
        pending: false,
        error: action.error
      };
    case SET_ACTIVE_TORRENT:
      return {
        ...state,
        active: action.torrent
      };
    case SET_ACTIVE_TORRENT_FILES:
      if (!state.active || state.active.id !== action.id) {
        return state;
      }
      return {
        ...state,
        active: {
          ...state.active,
          files: action.files,
          nodes: action.nodes
        }
      };
    case SET_ACTIVE_TORRENT_TRACKERS:
      if (!state.active || state.active.id !== action.id) {
        return state;
      }
      return {
        ...state,
        active: {
          ...state.active,
          trackers: action.trackers
        }
      };
    case SET_SELECTED_TORRENTS:
      return {
        ...state,
        selected: action.torrentIds
      };
    case TOGGLE_TORRENT_PENDING:
      return {
        ...state,
        list:
          state.list &&
          state.list.map(torrent => {
            if (torrent.id === action.torrentId) {
              return {
                ...torrent,
                pending: action.pending
              };
            }
            return torrent;
          }),
        active:
          state.active && state.active.id === action.torrentId
            ? {
              ...state.active,
              pending: action.pending
            }
            : state.active
      };
    case SYNC_TORRENT_STATS:
      return {
        ...state,
        list:
          state.list &&
          state.list.map(torrent => {
            const stat = action.diff.updated[torrent.hash];
            return stat
              ? {
                ...torrent,
                ...stat
              }
              : torrent;
          }),
        active:
          state.active && action.diff.updated[state.active.hash]
            ? {
              ...state.active,
              ...action.diff.updated[state.active.hash]
            }
            : state.active
      };
    default:
      return state;
  }
}
